import React from "react";
import SubmitButton from "../submitButton/SubmitButton";

const ClientFormActions = ({ onCancel, isLoading, translate, readOnly }) => (
  <div className="flex justify-between">
    <button
      type="button"
      onClick={onCancel}
      className="border px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
    >
      {translate("cancel")}
    </button>
    {!readOnly && (
      <SubmitButton
        isLoading={isLoading}
        text={translate("save")}
        textLoading={translate("saving")}
      />
    )}
  </div>
);

export default ClientFormActions;
